import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "options"]

  connect() {
    console.log("ToggleOptions controller connected")
    this.toggle()
  }

  toggle() {
    console.log("Toggle called, checkbox checked:", this.checkboxTarget.checked)
    if (this.checkboxTarget.checked) {
      this.optionsTarget.classList.remove("d-none")
    } else {
      this.optionsTarget.classList.add("d-none")
    }
  }
}
